export const faqData = [
  {
    id: 1,
    question: "What is an EMI, and how is it calculated?",
    answer:
      "EMI is the fixed monthly payment comprising both principal and interest.",
  },
  {
    id: 2,
    question: "How does my credit score affect EMI?",
    answer:
      "A higher credit score results in lower interest rates and EMIs, while a lower score increases both.",
  },
  {
    id: 3,
    question: "Can I reduce my EMI during the loan tenure?",
    answer:
      "Yes, by prepaying part of the loan or refinancing at a lower interest rate.",
  },
  {
    id: 4,
    question: " What is the difference between EMI and APR?",
    answer:
      "EMI is the monthly payment; APR includes interest and fees, giving a complete loan cost overview.",
  },
  {
    id: 5,
    question: "What happens if I miss an EMI payment?",
    answer:
      "Missing an EMI can lead to penalties, increased costs, and a negative impact on your credit score.",
  },
  {
    id: 6,
    question: "How can I use Minemi’s EMI Calculator effectively?",
    answer:
      "Input your loan amount, interest rate, and tenure to compare scenarios and choose the best option for your budget.",
  },
];
